import {
  poUploadJobFileIdFormat,
  poUploadJobIdFormat,
  purchaseOrderIdFormat,
} from "@redotech/redo-ids/ids";
import { unaryStreamRpc } from "@redotech/rpc/definition";
import * as z from "zod";

const PoUploadJobFileSchema_ = z.object({
  id: poUploadJobFileIdFormat.schema,
  fileName: z.string(),
  status: z.string(),
  purchaseOrderId: purchaseOrderIdFormat.schema.nullable(),
  errorMessage: z.string().nullable(),
  unmatchedItems: z.array(z.string()),
});
export interface PoUploadJobFile extends z.infer<
  typeof PoUploadJobFileSchema_
> {}
export const PoUploadJobFileSchema: z.ZodType<PoUploadJobFile> =
  PoUploadJobFileSchema_;

const PoUploadJobSchema_ = z.object({
  id: poUploadJobIdFormat.schema,
  status: z.string(),
  totalFiles: z.number(),
  completedFiles: z.number(),
  failedFiles: z.number(),
  createdAt: z.string(),
  files: z.array(PoUploadJobFileSchema),
});
export interface PoUploadJob extends z.infer<typeof PoUploadJobSchema_> {}
export const PoUploadJobSchema: z.ZodType<PoUploadJob> = PoUploadJobSchema_;

const PoUploadJobsUpdateSchema_ = z.object({
  jobs: z.array(PoUploadJobSchema),
});
export interface PoUploadJobsUpdate extends z.infer<
  typeof PoUploadJobsUpdateSchema_
> {}
export const PoUploadJobsUpdateSchema: z.ZodType<PoUploadJobsUpdate> =
  PoUploadJobsUpdateSchema_;

export const watchPoUploadJobs = unaryStreamRpc({
  name: "watchPoUploadJobs" as const,
  input: z.object({ jobIds: z.array(poUploadJobIdFormat.schema) }),
  output: PoUploadJobsUpdateSchema,
});
